import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Validated } from 'it/primatoo/openapi/api/org/schemas/common/docs/_findallvalidateddocresponse/Validated';
import { BusinessProjectManagementService } from '@pt/api-client';
import { PatchValidatedRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/PatchValidatedRequest';
import { MAX_LENGTH_VALIDATOR_KEY, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as DocumentsUtils from '../documents/utils/validator-generator';
import { ValidatorGenerator } from '../documents/utils/validator-generator';

@Component({
  selector: 'pt-edit-document-validated-dialog',
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ title | async }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <form [formGroup]="formGroup">
        <pt-input-text
          [controlName]='"newName"'
          formControlName='newName'
          [label]="'LABELS.NAME' | translate"
          [validators]='[REQUIRED, MAX_LENGTH]'
        ></pt-input-text>


        <pt-input-text-area
          formControlName='description'
          [minRow]="5"
          [label]="'LABELS.DESCRIPTION' | translate"
        ></pt-input-text-area>
      </form>
    </div>

    <div class='modal-footer' (click)='$event.stopPropagation()'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]="formGroup.invalid || formGroup.untouched"
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
  styles: [``]
})
export class EditDocumentValidatedDialogComponent {
  @Input() title: Observable<string>;
  public validated: Validated;
  private service: BusinessProjectManagementService;
  private docId: number;
  private newName: string;
  REQUIRED = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public MAX_LENGTH = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(MAX_LENGTH_VALIDATOR_KEY,[128]);

  formGroup = new FormGroup({
    newName: new FormControl(null, [Validators.required]),
    description: new FormControl(null)
  })
  constructor(public activeModal: NgbActiveModal) {
  }

  run(docId: number, validated: Validated, service: BusinessProjectManagementService) {
    this.validated = validated;
    this.docId = docId;
    this.service = service
    this.formGroup.setValue({
      newName: validated.name,
      description: validated.description
    });
    this.formGroup.markAsTouched();
  }

  confirm() {
    if (this.service) {
      const request: PatchValidatedRequest = this.formGroup.getRawValue();
      this.service.renameDocumentValidated(this.docId, this.validated.id, request).subscribe(
        () => {
          this.activeModal.close(true);
        }, () => {
          this.activeModal.close(false);
        }
      )
    }
  }


}

